import { render, staticRenderFns } from "./BlogCategories.vue?vue&type=template&id=0e74db21&scoped=true&"
import script from "./BlogCategories.vue?vue&type=script&lang=js&"
export * from "./BlogCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e74db21",
  null
  
)

export default component.exports